import { PathProvider } from '@contexts/PathContext'
import { usePreviousRoute } from '@hooks/usePreviousRoute'
import { AppLayout } from '@layouts/AppLayout'
import { PathContent } from '@components/enrollments/paths/PathContent'

export default function Paths() {
  const { backLabel } = usePreviousRoute()

  return (
    <PathProvider>
      <AppLayout
        backRoute={{
          label: backLabel,
        }}
        backgroundColor="$bg-chrome"
        hasPaddingBottom={false}
      >
        <PathContent />
      </AppLayout>
    </PathProvider>
  )
}
